import EventEmitter from 'eventemitter3';
var eventCenter = new EventEmitter();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}

export { eventCenter };
export var SYNC_EVENT = 'recharts.syncMouseEvents'; // eslint-disable-next-line no-redeclare


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/util/Events.js
// module id = 1375
// module chunks = 0 15